import {Breadcrumb, Button, Col, Form, InputGroup, Row} from 'react-bootstrap'
import {useCallback, useEffect, useState} from 'react'
import moment from 'moment'
import {toast} from 'react-toastify'
import {useLazyQuery} from '@apollo/client'
import {GET_ALL_LEAD_SOURCE_CATEGORIES} from '../../gql/queries/leadSourceQuery'
import {IResCatLeadSource} from './leadSourceTypes'
import {useDisclourse} from '../../hooks/useDisclourse'
import {ModalAddEditLeadSource} from './components/ModalAddEditLeadSource'
import {ModalAddEditCategory} from './components/ModalAddEditCategory'
import {cleanVariables, PaginationUtils} from '../shared/PaginationUtils'
import {SIZE_PAGE_DEFAULT} from '../../helpers/consts'
import {PaginationSection} from '../shared/PaginationSection'

export const LeadSourcePage = () => {
  const [gqlGetCategories, {data, error, refetch}] = useLazyQuery<IResCatLeadSource>(
    GET_ALL_LEAD_SOURCE_CATEGORIES,
    {
      fetchPolicy: 'no-cache',
    }
  )

  const [dataArr, setDataArr] = useState<IResCatLeadSource['allCategoryLeadSource']['edges']>([])
  const [expandedRows, setExpandedRows] = useState<Set<string>>(new Set())

  const [infoLeadSource, setInfoLeadSource] = useState<{id?: string; name?: string; idCat?: string; enabled?: boolean}>({})
  const [infoCategory, setInfoCategory] = useState<{id?: string; name?: string} | undefined>(undefined)

  const {isOpen: isOpenLeadSource, onClose: onCloseLeadSource, onOpen: onOpenLeadSource} = useDisclourse()
  const {isOpen: isOpenCategory, onClose: onCloseCategory, onOpen: onOpenCategory} = useDisclourse()

  const [first, setFirst] = useState(SIZE_PAGE_DEFAULT)
  const [currentPage, setCurrentPage] = useState(1)

  let totalElements = data?.allCategoryLeadSource?.totalCount ?? 0
  const totalPages = Math.ceil(totalElements / first)
  const {start, end} = PaginationUtils.getPaginationRange(currentPage, first, totalElements)

  const [formData, setFormData] = useState({
    text: '',
  })

  const updatePage = (n: number) => {
    setCurrentPage(n)
  }

  const handleFilters = useCallback(() => {
    const variables = cleanVariables({
      first,
      offset: (currentPage - 1) * first,
      name_Icontains: formData.text,
    })

    gqlGetCategories({variables})
  }, [currentPage, first, formData.text, gqlGetCategories])

  const toggleRow = (id: string) => {
    const newExpanded = new Set(expandedRows)
    if (newExpanded.has(id)) {
      newExpanded.delete(id)
    } else {
      newExpanded.add(id)
    }
    setExpandedRows(newExpanded)
  }

  useEffect(() => {
    handleFilters()
  }, [handleFilters])

  useEffect(() => {
    if (!data) return
    const {edges} = data.allCategoryLeadSource
    setDataArr(edges)
  }, [data])

  useEffect(() => {
    if (error) {
      toast.error(`Error: ${error.message}`)
    }
  }, [error])

  return (
    <div className='policies-page'>
      <header className='header'>
        <Breadcrumb>
          <Breadcrumb.Item className='d-blok d-md-none'>
            <span>
              <i className='bi bi-list fs-1' />
            </span>
          </Breadcrumb.Item>
          <Breadcrumb.Item>Lead Sources</Breadcrumb.Item>
        </Breadcrumb>
        <div className='d-flex align-items-center gap-2'>
          <Button
            size='sm'
            onClick={() => {
              setInfoCategory(undefined)
              onOpenCategory()
            }}
          >
            <i className='bi bi-plus fs-3' /> New Category
          </Button>
        </div>
      </header>
      <Row className='policies'>
        <Col md={12} lg={12} sm={12} xl={12} className='container'>
          <div className='policies-container'>
            <div className='title-header'>
              <h3>All Lead Source Categories</h3>
            </div>
            <div className='filters-header'>
              <InputGroup>
                <Form.Control
                  placeholder='Search by category name...'
                  onChange={(e) =>
                    setFormData((prev) => ({
                      ...prev,
                      text: e.target.value,
                    }))
                  }
                  onKeyDown={(e) => {
                    if (e.key === 'Enter') {
                      e.preventDefault()
                      handleFilters()
                    }
                  }}
                  value={formData.text}
                />
                <Button
                  onClick={() => handleFilters()}
                  variant='outline-success'
                  style={{border: '1px solid #dbdfe9'}}
                >
                  Search
                </Button>
              </InputGroup>
            </div>
            <div className='results-header'>
              <PaginationSection
                first={first}
                setFirst={(n) => {
                  setFirst(n)
                  setCurrentPage(1)
                }}
                currentPage={currentPage}
                totalPages={totalPages}
                start={start}
                end={end}
                totalPolicies={totalElements}
                updatePage={updatePage}
                PaginationUtils={PaginationUtils}
              />
            </div>
            <div className='list-carrier table-scrollable table-container'>
              <table className='table-scrollable table-scroll table table-striped table-hover'>
                <thead>
                  <tr role='row'>
                    <th className='fw-bold' style={{width: '50px'}}></th>
                    <th className='fw-bold'>Category Name</th>
                    <th className='fw-bold d-none d-lg-table-cell text-center'>Lead Sources</th>
                    <th className='fw-bold d-none d-lg-table-cell'>Created</th>
                    <th className='fw-bold d-none d-lg-table-cell text-center'>Actions</th>
                  </tr>
                </thead>
                <tbody>
                  {dataArr.map(({node}) => (
                    <>
                      <tr key={node.id} style={{cursor: 'pointer'}}>
                        <td className='px-2' onClick={() => toggleRow(node.id)}>
                          <i
                            className={`bi bi-chevron-${
                              expandedRows.has(node.id) ? 'down' : 'right'
                            } fs-4`}
                          />
                        </td>
                        <td className='px-4' onClick={() => toggleRow(node.id)}>
                          {node.name}
                        </td>
                        <td className='px-2 text-center' onClick={() => toggleRow(node.id)}>
                          {node.leadSourceSet.edges.length}
                        </td>
                        <td className='px-2' onClick={() => toggleRow(node.id)}>
                          {moment(node.created).format('DD MMM, YYYY')}
                        </td>
                        <td className='px-2 text-center'>
                          <div className='d-flex align-items-center justify-content-center gap-2'>
                            <Button
                              size='sm'
                              variant='outline-primary'
                              onClick={() => {
                                setInfoLeadSource({idCat: node.id})
                                onOpenLeadSource()
                              }}
                            >
                              <i className='bi bi-plus-circle' /> Add Lead Source
                            </Button>
                            <button
                              title='Edit Category'
                              style={{border: 0, backgroundColor: 'transparent', padding: 0, margin: 0}}
                              onClick={() => {
                                setInfoCategory({id: node.id, name: node.name})
                                onOpenCategory()
                              }}
                            >
                              <i className='bi bi-pencil-square text-primary fs-4' />
                            </button>
                          </div>
                        </td>
                      </tr>
                      {expandedRows.has(node.id) && (
                        <tr>
                          <td colSpan={5} style={{padding: 0, backgroundColor: '#f8f9fa'}}>
                            <div style={{padding: '15px 40px'}}>
                              <h6 className='mb-3'>Lead Sources in {node.name}</h6>
                              {node.leadSourceSet.edges.length === 0 ? (
                                <div className='text-muted text-center py-3'>
                                  No lead sources in this category yet
                                </div>
                              ) : (
                                <table className='table table-sm table-bordered'>
                                  <thead>
                                    <tr>
                                      <th>Name</th>
                                      <th className='d-none d-md-table-cell'>Created</th>
                                      <th className='text-center' style={{width: '80px'}}>Status</th>
                                      <th className='text-center' style={{width: '80px'}}>Actions</th>
                                    </tr>
                                  </thead>
                                  <tbody>
                                    {node.leadSourceSet.edges.map(({node: leadSource}) => (
                                      <tr key={leadSource.id}>
                                        <td>{leadSource.name}</td>
                                        <td className='d-none d-md-table-cell'>
                                          {moment(leadSource.created).format('DD MMM, YYYY')}
                                        </td>
                                        <td className='text-center'>
                                          <span className={`badge ${leadSource.enabled ? 'bg-success' : 'bg-secondary'}`}>
                                            {leadSource.enabled ? 'Active' : 'Inactive'}
                                          </span>
                                        </td>
                                        <td className='text-center'>
                                          <button
                                            title='Edit Lead Source'
                                            style={{border: 0, backgroundColor: 'transparent', padding: 0, margin: 0}}
                                            onClick={() => {
                                              setInfoLeadSource({
                                                id: leadSource.id,
                                                name: leadSource.name,
                                                idCat: node.id,
                                                enabled: leadSource.enabled,
                                              })
                                              onOpenLeadSource()
                                            }}
                                          >
                                            <i className='bi bi-pencil-fill text-primary' />
                                          </button>
                                        </td>
                                      </tr>
                                    ))}
                                  </tbody>
                                </table>
                              )}
                            </div>
                          </td>
                        </tr>
                      )}
                    </>
                  ))}
                </tbody>
              </table>
            </div>
          </div>
        </Col>
      </Row>

      {isOpenLeadSource && infoLeadSource.idCat && (
        <ModalAddEditLeadSource
          isOpen={isOpenLeadSource}
          onClose={onCloseLeadSource}
          info={infoLeadSource}
          refetch={refetch}
        />
      )}

      {isOpenCategory && (
        <ModalAddEditCategory
          isOpen={isOpenCategory}
          onClose={onCloseCategory}
          info={infoCategory}
          refetch={refetch}
        />
      )}
    </div>
  )
}
